import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    getCurrentCustomerCreditInformation,
    GetCurrentCustomerCreditInformationParameter,
} from "@store/Services/CreditInformationService";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";
import { CreditInformationModel } from "@store/Types/CreditInformation";

type Parameter = {
    apiParameter: GetCurrentCustomerCreditInformationParameter;
} & HasOnSuccess<CreditInformationModel> &
    HasOnError<any>;

type Props = StoreHandlerProps & {
    apiParameter: GetCurrentCustomerCreditInformationParameter;
    apiResult: CreditInformationModel;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    const { onError, ...parameter } = props.parameter;
    props.apiParameter = parameter.apiParameter;
};

export const DispatchBeginLoadCreditInformations: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/CreditInformations/BeginLoadCreditInformations",
        parameter: props.apiParameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    const apiResult = await getCurrentCustomerCreditInformation(props.apiParameter);
    if (apiResult.successful) {
        props.apiResult = apiResult.result;
    } else {
        props.parameter.onError?.(apiResult.errorMessage);
    }
};

export const DispatchCompleteLoadCreditInformations: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/CreditInformations/CompleteLoadCreditInformations",
        parameter: props.apiParameter,
        creditInformationModel: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadCreditInformations,
    RequestDataFromApi,
    DispatchCompleteLoadCreditInformations,
    ExecuteOnSuccessCallback,
];

const loadCreditInformation = createHandlerChainRunner(chain, "LoadCreditInformation");
export default loadCreditInformation;
